import React, { memo } from 'react';
import _ from 'lodash';
import { Row, Col } from '@duxton-web/ui';
import { Handle, Position } from 'reactflow';
import delayIcon from 'img/delay.svg';
import 'components/journey-builder/css/delay.scss';
import infoIcon from 'img/info.svg';
import { NODETYPE_REQUIRED_FIELDS, NODE_TYPES } from 'components/journey-builder/utils/constants';
import { getErrors } from 'components/journey-builder/utils/core';
import { MoreInfoFilled } from '@duxton-web/icons';

const Delay = memo(({ data, isConnectable }) => {
  const { isView, showMetrics } = data;
  const isRelative = _.get(data, 'type', '') === 'untilRelativeTime';
  const valueInDays = (isRelative ? _.get(data, 'relativeTime.waitInMin', '') : _.get(data, 'duration.waitInMin', '')) / (24 * 60);
  const text = valueInDays > 1 ? 'Days' : 'Day';
  const hasError = getErrors(data, NODETYPE_REQUIRED_FIELDS[NODE_TYPES.wait]);
  return (
    <div>
      {hasError && !isView && <MoreInfoFilled className="hasError" />}
      <Handle
        type="target"
        position={Position.Top}
        isConnectable={isConnectable}
      />
      <Row>
        <Col>
          <img src={delayIcon} height={'28px'} width={'28px'} alt={''} />
        </Col>
        <Col>
          <div className="title">
            <b>Delay #{data.nameIndex}</b>
          </div>
        </Col>
      </Row>
      <Row style={{ marginTop: 12 }}>
        <Col>
          <div className="categoryContent">
            {valueInDays} {text}
          </div>
        </Col>
      </Row>
      {showMetrics && data.processed_count > 0 && <div>
        <div className="divider" />
        <Row>
          <Col>
            <div className="progressTextHeader">
              Processed <img src={infoIcon} height={'12px'} width={'12px'} alt={''} />
            </div>
            <div className="progressTextContent">
              {((data.success_count / (data.totalCount || 0)) * 100).toFixed(1)} %
            </div>
          </Col>
        </Row>
      </div>}
      <Handle
        type="source"
        position={Position.Bottom}
        isConnectable={isConnectable}
      />
    </div>
  );
});

export default Delay;
